<template>
  <div class="holding-page">
    <HeaderComp />
    <h1>Thank you for participating.</h1>
    <p>This campaign has now closed.</p>
  </div>
</template>

<script setup lang="ts">
import HeaderComp from './HeaderComp.vue'
</script>

<style scoped>
.holding-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background-color: var(--vt-c-white);
  color: var(--vt-c-background-primary);
  padding-bottom: 15vh;
}

h1 {
  font-size: 2rem;
  margin-bottom: 2rem;
  text-decoration: underline;
  color: red;
  padding-top: 2rem;
}

p {
  font-size: 1.2rem;
  padding: 2rem;
}
</style>
